import React, { FC } from 'react';
import styled from 'styled-components';
import ProductSortByIcon from '@westwing/ui-kit/Icons/Svgs/ProductSortByIcon';
import IconButton from '@westwing/ui-kit/IconButton';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { useHeaderContext } from 'Components/HeaderContext';

const StyledIconButton = styled(IconButton)`
    color: ${({ theme }) => theme.colors.charcoal100};
`;

const StyledProductSortIcon = styled(ProductSortByIcon)`
    display: inline-block;
    height: 22px;
    width: 100%;
    vertical-align: middle;
`;

const Wrapper = styled.div`
    display: block;
    position: relative;

    ${forTablet`
        display: none;
    `}
`;

const StyledDropdown = styled.select`
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    width: 100%;
`;

export const SortButton: FC = () => {
    const { t } = useHeaderContext();
    const sortParam = 'sort';
    const urlParams = new URLSearchParams(window?.location?.search);
    const currentUrl = urlParams.get(sortParam);
    const {
        trackingHelpers: {
            ga: { trackNonInteractiveGenericEvent },
        },
    } = useHeaderContext();

    const options = [
        { label: t('OwwHeader_DEFAULT'), value: '' },
        { label: t('OwwHeader_PRICE'), value: 'price' },
        { label: t('OwwHeader_QUANTITY IN STOCK'), value: 'quantity' },
    ];

    const onChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
        trackNonInteractiveGenericEvent('CDP', { action: 'Sorting feature - Click' });

        const selectedValue = e.target.value;
        if (selectedValue !== options[0].value) {
            urlParams.set(sortParam, selectedValue);
        } else {
            urlParams.delete(sortParam);
        }
        window.location.search = urlParams.toString();
    };

    return (
        <Wrapper>
            <StyledIconButton aria-label="sort">
                <StyledProductSortIcon data-testid="oww-header-campaign-sort-button" />
            </StyledIconButton>
            <StyledDropdown
                data-testid="oww-header-campaign-sort-options-container"
                onChange={onChange}
                value={options.find(option => option.value === currentUrl)?.value ?? ''}
            >
                {options.map(option => (
                    <option key={option.label} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </StyledDropdown>
        </Wrapper>
    );
};
